import { render, staticRenderFns } from "./select_item.vue?vue&type=template&id=2f60126b&scoped=true&"
import script from "./select_item.vue?vue&type=script&lang=js&"
export * from "./select_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60126b",
  null
  
)

export default component.exports